<template>
    <v-content style="height: 100%">
        <Header title="downloads"></Header>

        <div class="downloads-container">
            <h2 class="cea-color text-left mb-3">เอกสารสำหรับดาวน์โหลด</h2>
            <hr class="cea-underline headline-divider mb-6">

            <div class="downloads-list">
                <v-layout align-center class="mb-6" justify-center>
                    <v-flex class="text-left">
                        คู่มือการใช้งานสำหรับผู้ใช้งานหน้าเว็บไซต์
                    </v-flex>
                    <v-flex class="text-right">
                        <v-btn
                                class="pr-7 text-start white--text titleHeader"
                                color="#FF4F23"
                                large
                                @click="downloadDoc('frontend')"
                        >
                            <v-icon class="mr-2">mdi-cloud-download</v-icon>
                            ดาวน์โหลด
                        </v-btn>
                    </v-flex>
                </v-layout>

                <v-layout align-center class="mb-6" justify-center>
                    <v-flex class="text-left">
                        คู่มือการใช้งานสำหรับผู้ใช้ระบบจัดการเนื้อหาเว็บไซต์ (Admin)
                    </v-flex>
                    <v-flex class="text-right">
                        <v-btn
                                class="pr-7 text-start white--text titleHeader"
                                color="#FF4F23"
                                large
                                @click="downloadDoc('backend')"
                        >
                            <v-icon class="mr-2">mdi-cloud-download</v-icon>
                            ดาวน์โหลด
                        </v-btn>
                    </v-flex>
                </v-layout>

                <v-layout align-center class="mb-6" justify-center>
                    <v-flex class="text-left">
                        เทมเพลตการนำเข้าข้อมูล
                    </v-flex>
                    <v-flex class="text-right">
                        <v-btn
                                class="pr-7 text-start white--text titleHeader"
                                color="#FF4F23"
                                large
                                @click="downloadDoc('template')"
                        >
                            <v-icon class="mr-2">mdi-cloud-download</v-icon>
                            ดาวน์โหลด
                        </v-btn>
                    </v-flex>
                </v-layout>

<!--                <v-layout align-center class="mb-6" justify-center>-->
<!--                    <v-flex class="text-left">-->
<!--                        รหัสแทนข้อมูล-->
<!--                    </v-flex>-->
<!--                    <v-flex class="text-right">-->
<!--                        <v-btn class="pr-7 text-start white&#45;&#45;text titleHeader"-->
<!--                               color="#FF4F23"-->
<!--                               large>-->
<!--                            <v-icon class="mr-2">mdi-cloud-download</v-icon>-->
<!--                            ดาวน์โหลด-->
<!--                        </v-btn>-->
<!--                    </v-flex>-->
<!--                </v-layout>-->
            </div>
        </div>
    </v-content>
</template>

<script>
    import Header from '../components/Header'

    export default {
        name: 'docs-download',
        components: {
            Header
        },
        methods: {
            downloadDoc(name) {
              alert('name',name);
                switch (name) {
                    case 'frontend':
                        window.open('https://data.cea.or.th/service/uploads/download/Frontend_Manual_CEA.pdf');
                        break;

                    case 'backend':
                        window.open('https://data.cea.or.th/service/uploads/download/Backend_Manual_CEA.pdf');
                        break;

                    case 'template':
                        window.open('https://data.cea.or.th/service/uploads/download/TemplateImport.xlsx');
                        break;
                }
            }
        }
    }
</script>

<style scoped>

    .theme--light.v-data-table thead tr td:not(:last-child),
    .theme--light.v-data-table tbody tr td:not(:last-child) {
        border-right: solid 1px #D7D7D7 !important;
    }

    .downloads-container {
        margin: 40px;
    }

    .downloads-list {
        margin-left: 100px;
        margin-right: 100px;
    }

    .headline-divider {
        border-top: 0;
        border-left: 0;
        border-right: 0;
    }

</style>
